<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
</ngx-spinner>

<div class="m-grid__item m-grid__item--fluid m-wrapper ">
    <div class="m-content">
        <div *ngIf="!showHeatmap" class="m-portlet" style="display: flex; flex-direction: column;">
            <div class="report-card">
                <div class="report-top">
                    <label style="font-size: 18px;">
                        {{reportTitle}}
                    </label>
                    <div class="key-container">
                        <div *ngFor="let color of colors; let i = index;" style="display: flex;">
                            <div [style.backgroundColor]="color" class="key-color"></div>
                            <label style="margin-left: 10px; margin-right: 10px;">{{breakdown[i]}}</label>
                        </div>
                        <div *ngIf="reportType === 3" style="display: flex; justify-content: center; margin-left: auto;">
                            <label style="margin-right: 0.5em;">
                            Heatmap Display
                            </label>
                            <div>
                                <label class="switch">
                                <input
                                    type="checkbox"
                                    [(ngModel)]="showHeatmap"
                                    />
                                <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <app-bar-graph
                    [bars]="bars"
                    [xAxis]="xAxis"
                    [yAxis]="yAxis"
                    [colors]="colors"
                    [width]="graphWidth"
                    [height]="graphHeight"
                    [isCurrency]="reportType === 1">
                </app-bar-graph>
                <div class="breakdown-container">
                    <div *ngFor="let breakdown of breakdownTypes; let i = index" style="display: flex;">
                        <chunky-check-box [checked]="breakdownType === breakdown" (changed)="onBreakdownTypeChange(breakdown)"></chunky-check-box>
                        <label class="breakdown-label">
                            {{reportService.getBreakdownDescription(breakdown)}}
                        </label>
                    </div>
                </div>
            </div>
            <div style="display: flex; margin: 5%; justify-content: space-between;">
                <button class="btn btn-danger" (click)="navigateUp()">
                    Go Back
                </button>
                <button class="btn btn-success" (click)="saveReport()">
                    Save Report
                </button>
                <button class="btn btn-success" (click)="downloadCSV()">
                    Download Report as .csv File
                </button>
            </div>
        </div>
        <div *ngIf="showHeatmap" class="m-portlet" style="display: flex; flex-direction: column;">
            <div *ngIf="reportType === 3" style="display: flex; padding-top: 5%; justify-content: right; padding-right: 5%">
                <label style="align-self: center; margin-right: 1em;">
                Heatmap Display
                </label>
                <div>
                    <label class="switch">
                    <input
                        type="checkbox"
                        [(ngModel)]="showHeatmap"
                        />
                    <span class="slider round"></span>
                    </label>
                </div>
            </div>
            <div *ngFor="let eventData of barData; let i = index;">
                <app-heatmap
                    [event]="barData[i]">
                </app-heatmap>
            </div>
        </div>
    </div>
</div>